let storeRef = null;
/*
 * @function bindStore binds the ref of store to storeRef variable
 * @export
 * @param {any} store
 */
export function bindStore(store) {
  storeRef = store;
}

/*
 * @function getStore
 * @param {function} cb callback function returns store
 */
export default function getStore() {
  return storeRef;
}



// WEBPACK FOOTER //
// ./src/libs/store.js